// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showlessButtonText {\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n  color: var(--primary-style-color);\r\n}\r\n  .showlessButtonText:hover {\r\n    color: var(--primary-style-color);\r\n  }\r\n", ""]);
// Exports
module.exports = exports;
